import { PageContainer } from 'components'
import React from 'react'
// import styled from 'styled-components'

export const RoundInstructionList = ({ instruction = '' }) => {
  return (
    <PageContainer>
      <div dangerouslySetInnerHTML={{ __html: instruction }} />
    </PageContainer>
  )
}
